export class User {
  constructor(
    // Google
    public id: string = null,
    public verified_email: boolean = null,
    public link: string = null,
    public local: string = null,
    public gender: string = null,

    // Ilexoidc
    public sub: string = null,
    public preferred_username: string = null,
    public groups: string = null,

    // Common
    public email: string,
    public name: string,
    public given_name: string,
    public family_name: string,
    public picture: string
  ) {}
}

export interface JsonUserParam {
  area: string[];
  category: string[];
}

export class UserParam {
  public area: string[];
  public category: string[];

  constructor(jsonUserParam?: JsonUserParam) {
    if (jsonUserParam && jsonUserParam.area) {
      this.area = jsonUserParam.area;
    }

    if (jsonUserParam && jsonUserParam.category) {
      this.category = jsonUserParam.category;
    }
  }
}
